import React from 'react'
import { array, func, string } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import Section from '@/components/Product/Section'
import ProductCard from '@/components/Product/Card'

const productsWrapper = css`
  display: flex;
  flex-wrap: wrap;
  margin-left: -12px;
  margin-right: -12px;

  .item-card-base {
    margin: 12px;

    ${mediaQueries.smallScreen()} {
      width: calc(50% - 24px);
    }

    ${mediaQueries.largeScreen()} {
      width: calc(33.3% - 24px);
    }

    ${mediaQueries.xlargeScreen()} {
      width: calc(33.3% - 24px);
    }
  }
`

const Products = ({ products, innerRef, type, id }) => {
  return (
    <Section id={id} ref={innerRef} title={type === 'Services' ? type : ''}>
      <div css={productsWrapper}>
        {products.map((app) => (
          <ProductCard app={app} key={app.id} id={app.id} />
        ))}
      </div>
    </Section>
  )
}

Products.propTypes = {
  products: array,
  innerRef: func,
  type: string,
  id: string,
}

export default React.forwardRef((props, ref) => (
  <Products innerRef={ref} {...props} />
))
